import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown, DatePickerField, EditFormContent, BaasicButton} from 'core/components';

function PumpStatusChangeTemplate({ editView }) {
    const {
        form,
        statusStore,
        selectedStatus
    } = editView;

    return (
        <React.Fragment>
        <div className="modal__header">
            <h3 className='modal__header__title'>Update Pump Status</h3>
        </div>
        <EditFormContent form={form}>
            <div className="modal__body">
                <div className="form__group">
                    <BaasicFieldDropdown field={form.$('pumpStatusId')} store={statusStore} />
                </div>
                {selectedStatus && selectedStatus.abrv == 'return-requested' &&
                <div className="form__group"> 
                    <DatePickerField field={form.$('dateReturnRequested')} />
                </div> }
                {selectedStatus && selectedStatus.abrv == 'returned' &&
                <div className="form__group">
                    <DatePickerField field={form.$('dateReturned')} />
                </div>}
                {selectedStatus && selectedStatus.abrv != 'return-requested' && selectedStatus.abrv != 'returned' &&
                <div className="form__group">
                    <DatePickerField field={form.$('dateSent')} />
                </div>}
            </div>
            <div className="modal__footer">
                <BaasicButton
                    type='submit'
                    className='btn btn--med btn--primary'
                    label="Submit"
                    rotate
                    icon={
                        form.submitting || form.validating
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                    disabled={form.submitting || form.validating}
                    onClick={form.onSubmit}
                />
            </div>
        </EditFormContent>
        </React.Fragment>
    )
}

PumpStatusChangeTemplate.propTypes = {
    editView: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(PumpStatusChangeTemplate);
